import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    approveShippingProfile,
    getShippingProfileDetails
} from '../../../../api/booking/booking';
import { openNotification } from '../../../../utils/helper';
import {
    BookingContainer,
    DetailsContainer
} from '../../../../components/dashboard/upsBooking/Styles';
import { Alert, Backdrop, Stack, TextField } from '@mui/material';
import BookingHeader from '../../../../components/dashboard/upsBooking/BookingHeader';
import { Button } from 'antd';
import ApprovalModalContent from '../../../../components/dashboard/upsBooking/ApprovalModalContent';
import CustomModal from '../../../../components/CustomModal';
import { ShippingProfileTableData } from '../../../../components/dashboard/upsBooking/ShippingProfileProps';

const ShippingProfileDetails = () => {
    const { reference } = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<ShippingProfileTableData | null>(null);
    const [loadingData, setLoadingData] = useState(false);
    const [contractNumber, setContractNumber] = useState('');
    const [error, setError] = useState<
        string | JSX.Element[] | JSX.Element | null | string[]
    >(null);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [inttraAlias, setInttraAlias] = useState<string>();
    const navigate = useNavigate();

    const fetchBooking = async () => {
        setLoadingData(true);
        try {
            const res = await getShippingProfileDetails(Number(reference));
            const { data } = res.data;
            setData(data);
            setLoadingData(false);
        } catch (error) {
            setLoadingData(false);
            if (error?.response) {
                openNotification('error', `Booking, Something went wrong`);
            } else {
                openNotification('error', `Booking, Something went wrong`);
            }
        }
    };
    useEffect(() => {
        fetchBooking();
    }, []);

    const approveFunction = async () => {
        setError(null);
        if (!contractNumber || !inttraAlias) {
            setError('Booking Number & Intra Alias are required');
        } else {
            setLoading(true);
            try {
                await approveShippingProfile(Number(reference), {
                    contractNumber,
                    inttraAlias
                });
                setLoading(false);
                setShowApproveModal(false);
                openNotification(
                    'success',
                    'Shipping Profile was approved successfully'
                );
                navigate('/bookings/overview');
            } catch (error) {
                setLoading(false);
                openNotification(
                    'error',
                    'Shipping Profile approval, Something went wrong'
                );
                const otherErrors: string[] = [];

                if (error?.response) {
                    if (error?.response?.data?.error) {
                        const resError = error?.response?.data?.error;

                        if (typeof resError === 'string') {
                            const errorList = (
                                <li key={`error-list-${1}`}>{resError}</li>
                            );
                            setError(errorList);
                        } else {
                            Object.entries(resError).forEach(([key, value]) => {
                                if (Object.keys(errors).includes(key)) {
                                    setErrors((prevState) => ({
                                        ...prevState,
                                        [key]: value as string
                                    }));
                                } else {
                                    otherErrors.push(value as string);
                                }
                            });

                            if (otherErrors.length > 0) {
                                const errorList = otherErrors.map(
                                    (element, index) => {
                                        return (
                                            <li key={`error-list-${index}`}>
                                                {element}
                                            </li>
                                        );
                                    }
                                );
                                setError(errorList);
                            }
                        }
                    } else {
                        setError(
                            error?.response?.data?.message ||
                                'Something went wrong'
                        );
                    }
                } else {
                    setError('Something went wrong');
                }
            }
        }
    };
    const breadcrumbs = [
        {
            title: 'Home',
            link: '/',
            active: false
        },
        {
            title: 'Bookings',
            link: '/bookings/overview',
            active: false
        },
        {
            title: 'Shipping Profile details',
            link: `/bookings/shipping-profile/${reference}/details`,
            active: true
        }
    ];

    return (
        <BookingContainer>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }}
                open={loadingData}
            >
                <img
                    src='/img/vectors/loadingcircles.svg'
                    alt='loading'
                    className='animate-spin'
                />
            </Backdrop>
            <Stack
                direction='row'
                alignItems='center'
                width='100%'
                justifyContent='space-between'
            >
                <BookingHeader {...{ breadcrumbs }} noHead />
                <Stack
                    direction='row'
                    alignItems='center'
                    className='buttons'
                    mb='1rem'
                >
                    <Button
                        className='cancel'
                        onClick={() => navigate(`/bookings/overview`)}
                    >
                        Back
                    </Button>{' '}
                    <Button onClick={() => setShowApproveModal(true)}>
                        Approve
                    </Button>
                </Stack>
            </Stack>
            {!loadingData && data !== null && (
                <DetailsContainer>
                    <div className='details-content flex-1'>
                        <h3>General</h3>

                        <Stack direction='row' className='flex-dets'>
                            <p>Business Name*</p>
                            <p>{data?.businessName || '--'}</p>
                        </Stack>

                        <Stack direction='row' className='flex-dets'>
                            <p>Booking No*</p>
                            <p>{data?.bookingNumber || '--'}</p>
                        </Stack>
                        <Stack direction='row' className='flex-dets'>
                            <p>BL Number</p>
                            <p>{data?.blNumber || '--'}</p>
                        </Stack>
                        <Stack direction='row' className='flex-dets'>
                            <p>Contract No</p>
                            <p>{data?.contractNumber || '--'}</p>
                        </Stack>
                        <Stack direction='row' className='flex-dets'>
                            <p>Shipping Line</p>
                            <p>{data?.shippingLineName || '--'}</p>
                        </Stack>
                    </div>

                    <div className='details-content flex-1'>
                        <h3>Requester Information</h3>

                        <Stack direction='row' className='flex-dets'>
                            <p>Full Name</p>
                            <p>
                                {data?.firstName + ' ' + data?.lastName || '--'}
                            </p>
                        </Stack>

                        <Stack direction='row' className='flex-dets'>
                            <p>Requester Contact Email</p>
                            <p>{data?.requesterContactEmail || '--'}</p>
                        </Stack>
                        <Stack direction='row' className='flex-dets'>
                            <p>Requester Contact Number</p>
                            <p>{data?.requesterContactNumber || '--'}</p>
                        </Stack>
                        <Stack direction='row' className='flex-dets'>
                            <p>Customer Number</p>
                            <p>{data?.customerNumber || '--'}</p>
                        </Stack>
                    </div>
                </DetailsContainer>
            )}
            {showApproveModal && (
                <CustomModal
                    maxWidth='md'
                    open={showApproveModal}
                    onClose={() => setShowApproveModal(false)}
                    title=''
                >
                    <ApprovalModalContent
                        type='Shipping Profile'
                        approveFunction={approveFunction}
                        cancelFunction={() => {
                            setContractNumber('');
                            setShowApproveModal(false);
                        }}
                        loading={loading}
                    >
                        {error && (
                            <div className='mt-4'>
                                <Alert severity='error'>{error}</Alert>
                            </div>
                        )}
                        <TextField
                            value={contractNumber}
                            margin='normal'
                            required
                            fullWidth
                            id='contractNumber'
                            label='Contract Number'
                            name='contractNumber'
                            onChange={(e) => {
                                setContractNumber(e.target.value);
                            }}
                        />
                        <TextField
                            value={inttraAlias}
                            margin='normal'
                            required
                            fullWidth
                            id='inttraAlias'
                            label='Intra Alias'
                            name='inttraAlias'
                            onChange={(e) => {
                                setInttraAlias(e.target.value);
                            }}
                        />
                    </ApprovalModalContent>
                </CustomModal>
            )}
        </BookingContainer>
    );
};

export default ShippingProfileDetails;
